
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 13.08a2.58 2.58 0 100-5.16 2.58 2.58 0 000 5.16z","stroke":"#9095A1","stroke-width":"2.064","stroke-miterlimit":"10","stroke-linecap":"square"}}),_c('path',{attrs:{"d":"M17.88 10.5a6.918 6.918 0 00-.162-1.473l2.334-1.767-1.72-2.98-2.703 1.14a6.87 6.87 0 00-2.546-1.478L12.72 1.04H9.28l-.363 2.902a6.869 6.869 0 00-2.546 1.479L3.668 4.28 1.948 7.26l2.334 1.767a6.794 6.794 0 000 2.946l-2.334 1.768 1.72 2.979 2.703-1.14a6.87 6.87 0 002.546 1.478l.363 2.902h3.44l.363-2.902a6.87 6.87 0 002.546-1.479l2.703 1.14 1.72-2.979-2.334-1.767c.107-.484.161-.978.162-1.473z","stroke":"#9095A1","stroke-width":"2.064","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    